import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../core';
import { LoaderService } from '../../core/loader.service';
import { AuthService } from '../../core/services/auth.service';
import { DesignService } from '../../core/services/design.service';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent implements OnInit {
  deleting = false;
  deletionCompleted = false;
  deletionError = '';

  public getUser() {
    return this.authService.getUser();
  }
  user = this.getUser();

  constructor(
    private designService: DesignService,
    private userService: UserService,
    private loaderService: LoaderService,
    private authService: AuthService,
    private router: Router
  ) {
    this.designService.setHeaderStyle('privacyAndPolicy');
  }

  ngOnInit() {
    this.user = this.authService.getUser();
  }
  deleteAccount() {
    if (this.deleting || this.deletionCompleted) {
      return;
    }

    this.deleting = true;
    this.deletionError = '';
    // Account deletion has a dedicated, descriptive progress state. Suppress the
    // generic request overlay so users see one loader rather than two layers.
    this.loaderService.disable = true;
    this.userService.deleteUserAccount().subscribe(
      (res) => {
        if (res?.success === 0) {
          this.deleting = false;
          this.deletionCompleted = true;
          this.clearLocalSession();
          return;
        }

        this.deletionError =
          res?.message || 'We could not delete your account. Please try again.';
        this.deleting = false;
      },
      (error) => {
        this.deletionError =
          error?.message ||
          error?.error?.message ||
          'We could not delete your account. Please try again.';
        this.deleting = false;
      }
    );
  }

  goToSignIn() {
    this.router.navigateByUrl('/login');
  }

  private clearLocalSession() {
    this.authService.removeLogFlag();
    this.authService.removeCookie();
  }
}
